import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../components/auth/auth.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-login',
    template: require('./login.html'),
    styles: [require('./login.component.css')],
})
export class LoginComponent implements OnInit {
    submitted = false;
    public navbar: boolean = false;
    AuthService;
    isLoggedIn;


    login_form = new FormGroup({
        emailid: new FormControl('', [Validators.required]),
        password: new FormControl('', [Validators.required])
    });
    customerId: any;
    userId: any;
    customers: any;
    closeResult: string;

    get f() {
        return this.login_form.controls;
    }

    static parameters = [AuthService, Router, ToastrService, ActivatedRoute, HttpClient];
    constructor(
        private authService: AuthService,
        private router: Router,
        private toastr: ToastrService,
        private activatedRoute: ActivatedRoute,
        private http: HttpClient,
    ) { }




    ngOnInit() {
        this.authService.logout();
    }


    getCustomerLists() {
        this.http.get('/api/users/getCustomer').subscribe((res) => {
            this.customers = res;
            console.log('customers', this.customers);
        })
    }


    loginUser(content) {
        console.log('login content', content);
        this.submitted = true;
        var data = {
            emailid: this.login_form.value.emailid,
            password: this.login_form.value.password,
            type:"web"
        }
        console.log('data ', data);
        
        this.authService.login(data)
            .subscribe((res: any) => {

                if (res.status == true) {
                    sessionStorage.setItem('currentUser', JSON.stringify(res));
                    sessionStorage.setItem('access_token', JSON.stringify(res.token))
                    this.router.navigate(['/dashboard']);
                } else {
                    console.log('status false', this.toastr);
                    this.toastr.error('Invalid username or password');
                }
            }, error=> {
                this.toastr.error(error.error.message);
            });
    }

}
